/**
 * Conférence d'ouverture — séminaire IA.
 *
 * 60 min de créneau, 46 min de matière, **35 slides**.
 *
 * ⚠️⚠️ CE FICHIER EST LA SEULE RÉFÉRENCE DE NUMÉROTATION. Les `num:` sont
 * séquentiels de 1 à 35 et se recalculent à chaque coupe. TOUS les numéros de
 * slide cités plus bas dans cet en-tête datent de générations antérieures et
 * sont FAUX — ils n'ont pas été repris un par un, parce qu'un commentaire à
 * moitié corrigé est plus dangereux qu'un commentaire visiblement périmé.
 * Pour situer une slide, lis la liste des objets, pas ce bloc.
 *
 * ÉTAT AU 08/09/2026 — passe de relecture d'Adrien sur l'OUVERTURE et
 * L'ENTRÉE DE L'USINE. Six remarques, portées d'abord dans le conducteur :
 *  · le logo. Le bandeau affichait `/logoGeo.svg` sur toutes les slides d'une
 *    conférence donnée chez un client. Le logo est désormais une propriété de
 *    la CONFÉRENCE (`data/conferences/index.js`), le séminaire porte celui de
 *    VIF, et la slide 2 le pose une fois sous le nom pour que la salle
 *    rattache la marque du bandeau à quelqu'un.
 *  · slide 2 : la slide contredisait le conducteur (« plus de 20 ans » contre
 *    « bientôt 30 », « Manager Delivery » contre « Manager chez VIF »). Le
 *    conducteur fait foi.
 *  · slide 3 : le cinquième point sortait par le bas de l'écran. Corrigé dans
 *    `StandardSlide` (mode dense au-delà de trois points), pas ici.
 *  · slide 4 : les trois paires ne parlaient qu'à des développeurs.
 *  · slide 6 : la file d'attente (« ils en demandaient quatorze ») retirée de
 *    la slide et du conducteur.
 *  · slides 7 et 8 INVERSÉES : les rendements avant le pronostic.
 * ⚠️ LE MINUTAGE DE L'OUVERTURE A CHANGÉ dans le conducteur (slide 3 → 1:20,
 * slide 4 → 2:15) : l'usine est atteinte vers 6:20 pour un repère resté à
 * 8:15, soit ~2 min de coussin qu'on ne redistribue pas. C'est délibéré — le
 * prompteur affichera une avance en vert, pas une dérive.
 *
 * ÉTAT AU 07/09/2026 — trois passes successives :
 *  1. L'OUVERTURE a changé d'ordre. Le miroir (« Où est le goulot ? ») est
 *     remonté en slide 3, avant le chapitre outil : le socle de la salle — des
 *     managers d'exploitation, aucun développeur — décide en cinq minutes si
 *     la conférence le concerne, et le mot « astreinte » tombait à 6:30. Il
 *     tombe à 2:45. Le statement « votre image de l'IA est fausse » a été
 *     fusionné dans le sous-titre de la comparaison (slide 4).
 *  2. LA CLÔTURE a été réécrite. Les deux slides du run disaient la même chose
 *     avec deux métaphores concurrentes (la cuve, puis le rempart) et ne
 *     débouchaient sur rien ; le retournement est passé DANS LE TITRE de la 32,
 *     et la seule consigne actionnable du talk est devenue le titre de la 33.
 *     La slide d'écriture demande maintenant DEUX lignes : le goulot, et ce que
 *     le manager demandera à son équipe lundi — cette salle est faite de relais
 *     qui représentent 640 personnes, et rien ne sortait de la salle.
 *  3. DEUX COUPES validées : l'ancien « Le goulot n'était pas d'écrire » (aucun
 *     texte au conducteur, redisait la chute de « L'expertise se déplace ») et
 *     l'ancien « Cette documentation n'a pas été impossible pendant vingt ans »
 *     (nuance sur la slide de forme, et le seuil de rentabilité est redit dans
 *     la chute de la slide de la voix IA). ~1 min 20 rendues.
 *     ⚠️ La note de la première portait une phrase qui, elle, ne doit pas
 *     disparaître : « nous n'avons pas accéléré le développement, nous avons
 *     supprimé du travail qui n'aurait jamais dû arriver jusqu'aux
 *     développeurs. » Elle se dit maintenant à l'oral, en fermeture du cas nº 2.
 *
 * `seminaire-CONDUCTEUR.md`, détruit le 07/09 puis reconstruit, fait foi pour
 * le texte parlé. Depuis le 18/09, `seminaire-ACTIONS.md`, `seminaire-SUPPORT.md`
 * et les fragments récupérés sont dans `docs/conferences/archive/` : périmés,
 * gardés pour l'historique. Ce qui reste à trancher est en fin de conducteur.
 *
 * ⚠️ LA MARGE EST MANGÉE. Le passage à l'oral de la slide 3 (main levée +
 * l'accompagnement des réticents) coûte ~2 min, la 4e apparition de la voix IA
 * ~20 s ; la suppression de l'ancienne slide 31 n'en rend que 45. La slide 9
 * (les rendements) en coûte ~45 de plus, mais elle en rend autant à la machine :
 * elle remplace la page de transition de l'usine, qu'on ne joue plus. Les trois
 * slides de BILAN (7, 11, 16) sont neutres pour la même raison : elles montrent
 * ce que la pop-in de la simulation montrait, et cette pop-in ne s'ouvre plus.
 *
 * LA MARGE A ÉTÉ REPRISE SUR LE CAS Nº 2, qui pesait douze slides contre trois
 * pour PULSE et deux pour la forge. Trois coupes et un allègement, ~2 min 45 :
 *   · l'ancienne slide 22 projetait « pas de correctif, aucune ligne de code
 *     écrite » — c'est la chute de la slide des 200/200, donnée une minute
 *     AVANT elle. On donnait la chute avant le chiffre.
 *   · l'ancienne slide 25 (« Pourquoi ça existe ») n'avait aucun texte parlé
 *     dans le conducteur, et un seul de ses trois points portait quelque chose.
 *     Ce point-là est passé à l'oral sur la slide 22.
 *   · l'ancienne slide 27 affichait « 750 » alors que le message transposable
 *     est « quelques semaines » — et la slide de la voix IA le réaffiche.
 *   · la slide 24 est passée de quatre points projetés à deux : les deux autres
 *     n'étaient pas commentés à l'oral.
 * ⚠️ AUCUNE IDÉE N'A ÉTÉ RETIRÉE DU TALK, quatre écrans l'ont été. Ce qui a été
 * coupé est repris à la voix dans `seminaire-CONDUCTEUR.md` — si tu récupères du
 * temps un jour, ne « remets » pas ces slides sans relire ce qui se dit
 * maintenant à leur place, sinon tu diras tout deux fois.
 * Chronométré au filage des 20 et 21/09 : 46 min de matière sur un créneau de 60. Voir la fin du
 * conducteur.
 *
 * PUBLIC (arrêté après échanges avec le contact) : 30 à 40 personnes d'une
 * production informatique, qui représentent 640 personnes dans un ensemble de
 * 3000. Ce sont des relais, pas des exécutants : chacun repart avec la charge
 * de retransmettre. TROIS SOUS-PUBLICS, et ils n'attendent pas la même chose.
 *
 *  A. LE SOCLE — la majorité. Managers d'équipes techniques d'EXPLOITATION :
 *     serveurs Windows, infra, RUN, batch, MEP, MCO, astreinte, support,
 *     IAM/sécurité, cellule de crise ITIL. 800 applications exploitées, et
 *     AUCUN développeur sous la main. Personne ici n'écrit de code.
 *  B. L'ÉQUIPE PILOTE IA — quelques personnes, déjà outillées, qui savent ce
 *     qu'est un agent. Ce sont elles qu'on interrogera après la conférence.
 *  C. LES COACHS — managérial, approche produit, devops, process de
 *     production. Ce sont eux qui animeront les ateliers de l'après-midi.
 *
 * LA CHARNIÈRE (slides 30 · 31) — c'est le passage qui a été refait, et il
 * répond au seul vrai défaut du montage précédent : la conférence démontrait
 * une thèse et exposait trois cas, mais ne donnait à la salle AUCUN instrument.
 * On lui demandait d'écrire son goulot après lui avoir montré trois réponses
 * dont on venait d'expliquer qu'aucune ne la concernait. Résultat de scène :
 * un catalogue d'exemples, pas une méthode.
 *   30 — l'instrument. Les trois endroits des trois cas deviennent trois
 *        sondes applicables ailleurs. C'est la seule slide-outil de la
 *        conférence, et la seule chose que la salle emporte.
 *   31 — la prédiction. Pour cette salle-là, et seulement pour elle, on peut
 *        dire où il va tomber : ils sont l'aval de la chaîne d'autres équipes.
 *
 * ⚠️ 19/09 — LA SLIDE DE LA QUESTION A ÉTÉ SUPPRIMÉE (décision d'Adrien).
 * Elle ouvrait la charnière en projetant « Trois produits, trois goulots,
 * trois endroits différents. C'est quoi, le vôtre ? » et n'y répondait pas —
 * la réponse, l'instrument, arrivait à l'écran suivant. Le conducteur n'en
 * portait déjà plus le texte parlé : la question se pose maintenant à l'oral,
 * par-dessus la grille. Tout ce qui suivait a été renuméroté (l'ancienne 31
 * est devenue 30, et ainsi de suite jusqu'à « La salle », 35).
 * Ne pas ramener l'instrument dans une `note` « pour gagner deux minutes » :
 * c'est exactement l'état d'où l'on vient, et il y était invisible.
 *
 * CONSÉQUENCES SUR LE MONTAGE
 *  - L'usine parle PO / Dev / Ops, jamais QA : le socle vit en aval de la
 *    chaîne, pas dedans.
 *  - Le fil destiné au SOCLE est le DÉPLACEMENT DE L'EXPERTISE vers le
 *    demandeur (slide 29, refermée slide 35) : une équipe d'experts au service
 *    de centaines d'applications ne se demande pas comment coder plus vite,
 *    elle se demande comment cesser d'être appelée pour ce qu'elle sait déjà.
 *  - Le fil destiné à l'ÉQUIPE PILOTE, c'est la courbe en J et la slide 18 :
 *    ils connaissent déjà les outils, ce qui leur manque est l'argument qui
 *    empêche leur direction d'arrêter l'initiative au creux. Plus la date de
 *    décembre 2025 en slide 30 : l'engagement d'abord, l'outil ensuite.
 *  - Le fil destiné aux COACHS, c'est le tour 3 (slide 14), la GRILLE DE
 *    DIAGNOSTIC (slide 33) et la clôture : « votre travail, ce n'est pas de
 *    déployer l'IA, c'est de courir derrière le goulot » est littéralement leur
 *    fiche de poste. C'est à eux que la slide 37 confie les goulots écrits par
 *    la salle — et la slide 33 est ce avec quoi ils les trieront.
 *  - Les 200 jours sont un petit chiffre à leur échelle. On ne le gonfle pas :
 *    on passe du volume au TAUX (slide 23), et on montre que le taux empire
 *    avec la taille de l'organisation.
 *  - ⚠️ POINT FAIBLE CONNU : la slide 3 est la plus « développeur » du deck et
 *    elle arrive à 2:45, au moment où l'on garde ou perd une salle. On ne
 *    l'aplatit pas — sa précision est ce qui la rend crédible — mais la
 *    transposition se fait à l'oral (voir le conducteur).
 *
 * La phrase unique, prononcée deux fois (slides 13 et 38, rappelée en 39) :
 *   « Avec l'IA, si vous ne changez rien, vous produisez moins qu'avant.
 *     Pas autant. Moins. »
 *
 * ⚠️ 19/09 — CINQ APPARITIONS DEPUIS LA SLIDE 35. La voix lit la synthèse des
 * questions de la salle, et c'est elle la dernière. Ce MP3-là n'est pas
 * pré-enregistré : il ne peut pas l'être, son texte n'existe qu'une fois les
 * questions arrivées. Il est fabriqué pendant la conférence, par le bouton
 * « ⟳ synthèse » du prompteur, et joué par F1 comme les quatre autres.
 * Voir `SalleSlide.jsx` et docs/conferences/seminaire-QUESTIONS-SALLE.md.
 *
 * LA VOIX IA — QUATRE apparitions PRÉ-ENREGISTRÉES (slides 1, 13, 26, 38). La 4e, en
 * slide 26, a été ajoutée sur demande d'Adrien : c'est la seule qui DÉMONTRE au
 * lieu de faire rire — la machine se désigne elle-même comme la lectrice de la
 * documentation que personne n'ouvre. Les quatre sur `trigger` + `mode: "tts"`,
 * donc déclenchées à la touche F1.
 * Ne pas les passer en `transition` : ce champ ne se déclenche que si la case
 * à cocher masquée sous le compteur de slides est activée, et elle ne l'est
 * pas par défaut.
 *
 * LES ACTIONS À LA FLÈCHE (24/09). La télécommande n'a que « suivant » et
 * « précédent » : pas de F1, pas de souris pour le bouton d'analyse. Une slide
 * qui déclare `action` consomme donc le PREMIER appui sur « suivant » pour la
 * jouer, et ne change de slide qu'au second :
 *   · `action: "f1"`       — la voix IA (slides 1, 12, 23, 33 et 35) ;
 *   · `action: "synthese"` — l'analyse des questions de la salle (slide 32),
 *                            lancée par le prompteur, qui doit être ouvert.
 * F1 au clavier marche toujours, et compte comme l'appui : la flèche suivante
 * change alors de slide au lieu de rejouer la réplique. Voir
 * `handleSlideNavigation` dans ConferencePage.
 *
 * LES QUATRE RÉPLIQUES SONT PRÉ-ENREGISTRÉES. Le champ `voix` de chaque slide
 * pointe un MP3 de `public/conference/voix/`, généré une fois pour toutes :
 *
 *     python scripts/generer-voix.py src/data/seminaireSlidesData.js
 *
 * F1 lit ce fichier, sans appel API, sans crédit TTS et sans dépendre du
 * réseau de la salle — la génération live restant le repli automatique si le
 * fichier manque. Conséquence à connaître : le déroulé ne fait plus AUCUN appel
 * au backend, donc plus besoin de session admin pour le jouer.
 * ⚠️ Si tu modifies un `trigger`, le MP3 ne suit pas tout seul : relancer le
 * script avec `--force`, sinon la salle entendra l'ancienne version.
 *
 * ⚠️ À AJUSTER AVANT LE JOUR J
 *  - Slide 5  : les cinq étapes couvrent aujourd'hui demande → run, ce qui
 *               marche pour toute la salle. À remplacer par leurs noms réels
 *               si le contact les donne.
 *  - Slide 23 : le « 800 applications » a été RETIRÉ (jamais confirmé, et la
 *               phrase est plus forte sans chiffre). Ne pas le remettre sans
 *               validation du contact.
 *
 * RÉSERVE — `seminaireSlidesReserve` en bas de fichier. La typing-race en est
 * sortie : son ⚠️ (volume de frappe à compter) n'est pas levé, et devant une
 * salle majoritairement non développeuse elle coûte deux minutes que le cas
 * nº 3 rend bien mieux. Elle se remet dans le flux en une ligne.
 *
 * L'USINE — TROIS PASSAGES (slides 6, 10, 15), UNE SEULE TOUCHE
 * La simulation « LES BASSINS » tourne dans une iframe persistante servie depuis
 * `public/usine/`. Elle est montée une seule fois pour toute la conférence et
 * garde son état entre deux passages : on sort vers le diaporama après la manche
 * I et on revient dans la manche II sans rien relancer.
 *
 * SUR SCÈNE IL N'Y A QUE LA FLÈCHE DROITE. Le champ `usine: 1 | 2 | 3` d'une
 * slide annonce le passage qu'elle ouvre ; la machine se met alors d'elle-même
 * dans l'état que la slide promet, et chaque → avance d'un cran dans une séquence
 * écrite d'avance (visite du plateau → tours → bilan). Quand le passage est fini,
 * la flèche n'est plus consommée et rend la main au diaporama : la même touche
 * fait donc avancer la machine puis la slide, sans qu'on ait à savoir laquelle
 * des deux on pilote. La séquence vit dans `public/usine/src/ui/conductor.js` —
 * c'est le seul endroit à modifier pour la changer.
 *
 * Les dix commandes d'atelier (espace, d, p, a, r, n, +, o, g, v) restent
 * vivantes mais ne servent plus qu'en secours, si la séquence part de travers en
 * public. La flèche GAUCHE sort toujours vers le diaporama, quoi qu'il arrive.
 *
 * ⚠️ DEUX ÉCRANS DE LA SIMULATION NE SONT PLUS JOUÉS, et ils sont devenus des
 * slides. Si tu remets un jour la machine en pilotage manuel, ils reviendront et
 * feront doublon — il faudra alors retirer les slides correspondantes.
 *   · la PAGE DE TRANSITION entre manches  → slide 9 (les rendements)
 *   · la POP-IN DE BILAN de fin de manche  → slides 7, 11 et 16
 * Le bilan a été sorti de la simulation parce que c'est un panneau quasi-noir sur
 * fond assombri : en séance, l'écran entier basculait dans le sombre le temps du
 * bilan, puis en ressortait à la slide suivante. Le template `manche-bilan` dit
 * exactement la même chose — mêmes tours, mêmes totaux, même dette — dans la
 * langue visuelle du talk. ⚠️ Ses chiffres sont ÉCRITS EN DUR : ils viennent d'un
 * rejeu du moteur et ne se recalculent pas. Si `usine/src/config/rounds.js` bouge,
 * rejoue les trois manches et reporte les valeurs.
 *
 * Les champs `tanks` / `flow` / `overflow` ci-dessous ne servent qu'au repli
 * visuel si l'iframe ne charge pas.
 */
/**
 * LES TROIS CAS DE « PREUVE TERRAIN ».
 *
 * Le chapitre dure dix-neuf slides — un tiers du talk — et le bandeau y
 * affichait le même mot du début à la fin. Rien ne signalait qu'on changeait de
 * produit : le cas nº 2 tient douze slides d'affilée, et son repère était noyé
 * dans un sous-titre. Chaque cas porte donc son ton, et ce ton se voit à trois
 * endroits — le bandeau (sur toutes ses slides), le kicker et le titre de sa
 * slide d'ouverture, et enfin les cartes de « Où chercher le vôtre ».
 *
 * ⚠️ LA CHARNIÈRE (36 · 37) N'A PAS DE `cas`, ET C'EST VOULU. Elle ne parle plus
 * d'un produit mais des trois ensemble : le bandeau y reprend « PREUVE TERRAIN »
 * en grand, et la salle voit qu'on a changé d'altitude sans qu'un mot soit dit.
 * Ne pas lui coller un ton « pour finir la série ».
 *
 * ⚠️ `ton` doit valoir une clé d'ACCENTS (helpers.js) et l'`accent` de la slide
 * d'ouverture doit valoir le même : une couleur de titre qui contredit le
 * bandeau est pire que pas de couleur du tout.
 *
 * Les libellés sont COURTS parce qu'ils partagent la barre du haut avec le logo
 * et l'orbe du speaker. « Cas 2 · l'ERP historique et ses vingt ans de code » y
 * passerait sous le menton de l'orbe.
 */
const CAS = {
    1: { ton: "cyan", label: "Cas 1 · PULSE" },
    2: { ton: "amber", label: "Cas 2 · l'ERP historique" },
    3: { ton: "violet", label: "Cas 3 · la forge" }
};

export const seminaireSlidesData = [
    // ───────────── Ouverture (0:00 → 0:07:57) — 4 slides, le miroir dedans ─────────────
    {
        chapitre: "Ouverture",
        num: 1,
        type: "title",
        template: "title",
        title: "L'IA n'accélère pas ce que vous croyez",
        subtitle: "Ce que dix-huit mois de déploiement nous ont appris sur le vrai goulot",
        author: "Adrien Giguelay",
        date: "2026",
        // 24/09 — LE QR DÈS L'ACCUEIL (retour de la répétition). Cette slide
        // reste à l'écran pendant que la salle s'installe : personne n'écoute
        // encore, c'est le moment de remplir le formulaire sans rien rater.
        // La slide 3 garde son QR et devient la relance. Voir `QrSalle.jsx`.
        salleQr: true,
        salleQrInvitation: "En attendant le début : 3 questions, 30 secondes.",
        // 23/09 — LA 1re RÉPLIQUE DE LA VOIX IA EST UNE VIDÉO, plus un MP3.
        //
        // `videoVoix` prend la place de `voix` : F1 ne joue plus un son
        // par-dessus la slide, il passe la vidéo en plein écran (17,6 s), puis
        // rend l'écran à la slide de titre — et c'est là qu'Adrien enchaîne
        // avec « Merci pour cette introduction ». Voir `VoixVideo` dans
        // ConferencePage, et le conducteur, slide 1.
        //
        // ⚠️ LE MP3 RESTE SUR DISQUE (`seminaire-voix-1.mp3`). Il ne sert plus,
        // mais c'est le repli de scène : si la vidéo ne part pas, on remet
        // `voix:` à la place de `videoVoix:` et tout refonctionne comme avant.
        // Ne pas le supprimer avant que la conférence soit passée.
        //
        // ⚠️ `trigger` reste, et ne coûte rien : la slide portant un média
        // local, le préchargement TTS est court-circuité (voir
        // `useConferenceScenario`). Il sert de texte dans les logs, et c'est la
        // seule trace écrite de ce que la vidéo dit.
        //
        // ⚠️ LE FICHIER EST RÉ-ENCODÉ, PAS LA COPIE DE L'EXPORT PREMIERE.
        // L'export d'origine faisait 19,8 Mo pour 17,6 s — 9,1 Mbit/s en 720p,
        // soit 6 fois ce que la même image demande. Recompressé en H.264
        // CRF 18 : 3,0 Mo, PSNR 50,4 dB (au-delà de 45, l'œil ne distingue
        // plus), `+faststart` pour qu'il démarre sans être entièrement chargé.
        // Ne pas y recoller l'export brut : git garde tout ce qu'on lui donne,
        // et 17 Mo de plus resteraient dans l'historique pour toujours.
        //
        //     ffmpeg -i intro_ia.mp4 -c:v libx264 -preset slow -crf 18 \
        //            -pix_fmt yuv420p -c:a aac -b:a 160k -movflags +faststart \
        //            public/conference/voix/seminaire-voix-1.mp4
        videoVoix: "/conference/voix/seminaire-voix-1.mp4",
        action: "f1",
        mode: "tts",
        trigger: "On me demande d'ouvrir un séminaire sur l'intelligence artificielle. Merci à Michel pour l'invitation : il a préféré partir en voyage plutôt que de passer la journée avec vous. Je transmets. Quant à vous, rassurez-vous : votre travail, je n'en veux pas. J'ai regardé votre backlog."
    },
    {
        chapitre: "Ouverture",
        num: 2,
        type: "content",
        template: "speaker-intro",
        title: "Adrien Giguelay",
        subtitle: "Manager chez VIF — éditeur nantais d'ERP agroalimentaire",
        image: "speaker",
        // Le logo n'est pas décoratif : le bandeau porte la marque VIF pendant
        // quarante minutes sans jamais dire de qui il s'agit. C'est ici, et une
        // seule fois, que la salle fait le lien.
        logo: "/logoVIF.svg",
        // Deux périmètres à ne pas confondre, et c'est tout l'intérêt du profil :
        //  - le terrain (l'ERP legacy, 80 personnes) d'où viennent les chiffres ;
        //  - le déploiement IA (les 150, tous produits) qui donne la vue d'ensemble.
        //
        // ⚠️ CHIFFRES ALIGNÉS SUR LE CONDUCTEUR (08/09). La slide disait « plus
        // de 20 ans » quand Adrien dit « bientôt 30 » à voix haute, et le
        // sous-titre annonçait « Manager Delivery » quand il se présente comme
        // « Manager chez VIF ». Sur une slide dont le seul travail est d'acheter
        // la crédibilité des quarante minutes qui suivent, un écran qui
        // contredit la bouche du présentateur est le pire endroit possible.
        // La règle retenue : le conducteur fait foi, la slide suit.
        // « La moitié de l'entreprise » est neuf à l'écran — 150 est un nombre
        // abstrait, une moitié ne l'est pas.
        //
        // ⚠️ Les quatre points ne sont PLUS un CV. Le stack (Angular, AWS,
        // multi-tenant) est retiré de la projection : devant des managers
        // d'exploitation il n'achète rien, et il coûte la seule chose qui compte
        // ici — l'attention des trente premières secondes. Progress OpenEdge
        // reste : c'est lui qui dit « vraiment vieux », et c'est la crédibilité.
        // Java reste avec lui, parce qu'Adrien le dit : un legacy n'est presque
        // jamais monolingue, et la salle le sait.
        // Le périmètre delivery (cœur + modules web) se DIT, il ne se projette plus.
        //
        // Le point 2 projette « 50 personnes qui ne développent pas ». Ce chiffre
        // n'était qu'à l'oral ; dans une salle SANS AUCUN développeur, c'est le
        // seul chiffre de la slide auquel ils peuvent s'identifier. Il resservira
        // vingt minutes plus tard. La répartition fine (60 feature / 30
        // spécifique / 10 maintenance) ne se projette JAMAIS et ne se dit pas ici :
        // elle se dit juste avant les 200 jours, où elle sert de rampe de
        // lancement. Ne pas annoncer le chiffre « 10 » ici — sinon la bascule
        // est éventée vingt minutes trop tôt.
        //
        // Le point 4 est NEUF à l'écran : c'est le contrat du talk (« une méthode,
        // pas une recette »). Il n'existait qu'à l'oral, et il n'était tenu que
        // quarante minutes plus tard, sur « Où chercher le vôtre ». Une promesse
        // qu'on ne montre pas est une promesse que la salle ne peut pas nous
        // opposer — ni créditer quand on la tient.
        points: [
            "Un cœur d'ERP de bientôt 30 ans — Progress OpenEdge et Java, 80 personnes dessus, la majorité du chiffre d'affaires. Et sa refonte from scratch juste à côté.",
            "150 personnes sous IA — la moitié de l'entreprise. Une centaine de développeurs, et 50 personnes qui ne développent pas.",
            "J'ai le legacy et le neuf sous les yeux. Les trois cas que je vais vous montrer viennent des deux.",
            "Ce n'est pas une recette à recopier. C'est une méthode pour trouver la vôtre."
        ]
    },
    {
        chapitre: "Ouverture",
        num: 3,
        type: "content",
        template: "standard",
        // 19/09 — LE FORMULAIRE DE LA SALLE S'OUVRE ICI, et c'est le seul
        // moment de la matinée où on demande à la salle de sortir son
        // téléphone. (24/09 : le QR est aussi sur la slide 1, pendant
        // l'accueil ; celle-ci devient la relance des retardataires.) Le QR, l'adresse courte, le code et le compteur qui monte
        // sont posés par-dessus le gabarit (voir `QrSalle.jsx`).
        //
        // ⚠️ L'URL N'EST PAS DANS CE FICHIER, ET ELLE NE DOIT PAS Y ÊTRE : elle
        // porte le code de la salle, et ce fichier part en clair dans le bundle
        // de Vercel. Le QR lit son contenu sur `/api/salle/lien`, avec le jeton
        // admin du diaporama. Voir docs/conferences/seminaire-QUESTIONS-SALLE.md.
        //
        // ⚠️ La règle du conducteur — « jamais la main levée de la slide 3 » —
        // vaut désormais pour le formulaire : c'est ce qui les fait entrer, et
        // c'est le seul canal des questions de toute la matinée.
        salleQr: true,
        title: "Où est le goulot ?",
        subtitle: "Dans votre équipe, aujourd'hui, sans IA — l'étape qui plafonne toutes les autres.",
        // ⚠️ CETTE SLIDE A ÉTÉ REMONTÉE (elle était en 5, après le chapitre outil).
        //
        // Pourquoi. Le socle de la salle — des managers d'exploitation, aucun
        // développeur — décide en cinq minutes si la conférence le concerne.
        // Dans l'ancien montage il recevait dans ces cinq minutes : une vanne,
        // un CV d'éditeur de logiciel et deux colonnes de code. Le premier mot
        // qui parlait de lui — « astreinte » — tombait à 6:30. Il tombe
        // maintenant à 2:45.
        //
        // L'ordre inverse est aussi le plus logique : la slide dit
        // « aujourd'hui, sans IA ». Chercher son goulot ne demande donc AUCUNE
        // connaissance de l'outil. On peut le faire avant d'en parler.
        //
        // Elle enchaîne directement sur le point 4 de la slide précédente
        // (« une méthode pour trouver la vôtre ») : la méthode commence ici,
        // à la première seconde, et pas quarante minutes plus tard.
        //
        // La chaîne va volontairement jusqu'au run : une bonne partie des
        // managers n'a aucun développeur sous la main et s'arrêterait de se
        // sentir concernée à l'étape 2. Les cinq étapes sont génériques pour
        // que chacun place son propre goulot dessus.
        points: [
            "1. La demande — qui l'exprime, qui la qualifie",
            "2. La réalisation — un développement, un script, une configuration",
            "3. La validation — la recette, les tests, le contrôle",
            "4. La mise en production — le déploiement, le changement",
            "5. Le run — l'incident, l'astreinte, le support"
        ]
    },
    {
        chapitre: "Ouverture",
        num: 4,
        type: "content",
        template: "comparaison",
        title: "De l'assistant à l'agent",
        // ⚠️ CETTE SLIDE A FUSIONNÉ AVEC L'ANCIENNE SLIDE 4 (le statement
        // « votre image de l'IA est fausse »), qui a été SUPPRIMÉE.
        //
        // Pourquoi. Les deux faisaient le même travail : la comparaison
        // DÉMONTRAIT que l'outil a changé, le statement l'AFFIRMAIT juste
        // après. Une redite de quarante-cinq secondes sur un créneau qui n'en
        // a pas. La chute du statement est récupérée telle quelle dans le
        // sous-titre — elle ne perd rien, elle arrive plus tôt.
        //
        // ⚠️ 08/09 — LES TROIS PAIRES ONT ÉTÉ DÉ-DÉVELOPPÉES. Elles disaient
        // « 5000 lignes », « refactorise », « ouvrent des branches » : trois
        // exemples qui n'existent que si on écrit du code, devant une salle qui
        // n'en écrit pas. Le mécanisme est identique (copier-coller → décrire
        // une intention ; répondre → agir ; exécuter → valider), mais il est
        // maintenant dit dans des mots qui marchent aussi pour un script, une
        // configuration ou un ticket.
        //
        // C'était la slide la plus « développeur » du deck. Ce qui la rattrape
        // n'est pas une version édulcorée (sa précision fait sa crédibilité),
        // c'est LA MAIN LEVÉE qui la précède — voir le conducteur. Elle tombe
        // sur une salle déjà entrée par le miroir, et non sur une salle à qui
        // l'on n'a encore rien demandé.
        //
        // ⚠️ 09/09 — LE SOUS-TITRE A ÉTÉ RAMENÉ À UNE LIGNE. Il en faisait trois
        // et portait trois idées : le langage inchangé, l'outil qui agit, et la
        // chute « votre image décrit un outil qui n'existe plus ». Trois idées
        // dans le seul bloc de texte que la salle lit AVANT tout le reste, donc
        // trois idées lues à moitié. Il ne porte plus que le mécanisme ; la
        // chute est descendue en légende de la figure, à sa vraie place — après
        // la preuve, pas avant.
        subtitle: "On parle toujours à un LLM, dans un chat, en français. Mais il ne répond plus : il agit.",
        // ⚠️ DEUX LIGNES PAR COLONNE, pas trois — 09/09, sur la formulation
        // d'Adrien. La rangée 1 est L'ÉCHANGE (ce que je donne, ce qui revient),
        // la rangée 2 CE QUE J'EN FAIS. Le troisième couple disait « elle
        // répond / il agit », c'est-à-dire ce que le titre annonce déjà.
        // Le détail reste dans le conducteur : c'est ce qui se dit et ne se
        // projette pas.
        left: {
            label: "Il y a un an",
            points: [
                "Je copie ma question. Elle répond dans le chat.",
                "Je recolle les résultats à la main, et je vérifie."
            ]
        },
        right: {
            label: "Aujourd'hui",
            points: [
                "Je décris l'intention. Le contexte donne le cadre.",
                "L'IA agit. Je valide."
            ]
        },
        // ⚠️ 08/09 — LE DEUXIÈME COUPLE A CHANGÉ. Il disait « je demande tout
        // d'un coup, le résultat est aléatoire » : un reproche de méthode, donc
        // une faute de l'utilisateur, qui donnait raison à ceux de la salle qui
        // ont essayé et abandonné. Il dit maintenant la contrainte de l'outil —
        // la mémoire — qui est la vraie raison du copier-coller de la ligne du
        // dessus, et la seule des trois qui se mesure.
        //
        // ⚠️ 09/09 — LA FIGURE N'A PLUS AUCUN LIBELLÉ. Ni titre, ni unité, ni
        // légende : les barres portent déjà « 6 pages » et « 1 500 pages »,
        // l'année et le modèle. Le graphique parle de pages, on le laisse
        // parler. La chute (« ×250 en trois ans, l'outil que vous avez essayé
        // n'existe plus ») n'est donc PLUS PROJETÉE — elle se dit, et elle est
        // dans le conducteur. Ne pas la remettre ici.
        //
        // ⚠️ CHIFFRES À VÉRIFIER AVANT LE JOUR J — ils bougent tous les six
        // mois, et la salle compte au moins une personne qui les connaît.
        // Fenêtres de contexte des modèles grand public à la date indiquée ;
        // l'équivalent en pages retient 500 mots par page et ~0,75 mot par
        // token. Les pages sont l'unité projetée, les tokens se disent.
        //
        // ⚠️ ÉCHELLE LINÉAIRE (09/09). Elle était logarithmique, et c'était une
        // erreur : 6 pages y occupait plus de la moitié de la hauteur de 1 500,
        // donc le graphique disait « même ordre de grandeur » au moment précis
        // où la slide dit l'inverse. En linéaire, 6 et 50 sont des traits — et
        // c'est le propos. Voir la note d'en-tête de `ComparaisonSlide.jsx`.
        figure: {
            steps: [
                { year: "2022", model: "ChatGPT", tokens: "4 k tokens", pages: 6, display: "6 pages" },
                { year: "2023", model: "GPT-4", tokens: "32 k tokens", pages: 50, display: "50 pages" },
                { year: "2024", model: "Claude 3", tokens: "200 k tokens", pages: 300, display: "300 pages" },
                { year: "2026", model: "Opus 5", tokens: "1 M tokens", pages: 1500, display: "1 500 pages" }
            ]
        }
    },
    // ───────────────────────── L'usine (0:07:57 → 0:22:41) ────────────────────
    {
        chapitre: "L'usine",
        num: 5,
        type: "content",
        template: "factory",
        // PASSAGE 1 : la visite du plateau etage par etage, puis les cinq tours
        // sans IA d'un trait. Le bilan est la slide SUIVANTE, plus une pop-in.
        // Voir usine/src/ui/conductor.js.
        usine: 1,
        stage: "Manche I — le nominal",
        title: "Trois cuves : PO, Dev, Ops",
        subtitle: "Le fluide, c'est le travail. Ce qui compte n'est pas ce qui entre — c'est ce qui sort.",
        tanks: [
            { label: "PO", fill: 45 },
            { label: "Dev", fill: 50 },
            { label: "Ops", fill: 55 }
        ],
        flow: { label: "Débit en sortie", value: 60, trend: "flat" },
        points: [
            "Le débit d'une chaîne n'est jamais la somme des débits. C'est le débit du plus lent."
        ]
    },
    {
        chapitre: "L'usine",
        num: 6,
        type: "content",
        template: "manche-bilan",
        title: "La référence",
        // ⚠️ 09/09 — PAS DE SOUS-TITRE, PAS DE NOTE, sur décision d'Adrien, et
        // c'est la même raison pour les deux : ils DISAIENT l'histogramme. « Cinq
        // tours, cinq features par tour » et « cinq par tour, tour après tour »
        // décrivaient cinq barres égales qui sont déjà à l'écran, en grand. Une
        // salle qui lit une phrase ne regarde pas le graphique qu'elle décrit :
        // on payait donc deux lignes pour rendre la seule image de la slide
        // invisible. Ce qui restait d'utile — « il n'y a pas un gramme de gras »,
        // « la seule manche où il ne se passe rien » — est du commentaire, et le
        // commentaire se dit. Il est dans le conducteur.
        // Ne pas les remettre : la slide n'a plus qu'un sujet, et c'est voulu.
        //
        // ⚠️ Chiffres relevés en rejouant la manche dans le moteur. Ils sont
        // déterministes, mais ils ne se recalculent pas : si `rounds.js` bouge,
        // ces trois slides mentent en silence. Voir l'en-tête du template.
        //
        // `detteDepart` : la dette AVANT la manche (RULES.INITIAL_DEBT = 32 dans
        // rounds.js). Sa présence déclenche l'affichage « 32 +5 = 37 » — voir le
        // template. Elle n'est renseignée QUE sur cette slide : les deux slides
        // de récapitulatif alignent deux et trois manches dans la même hauteur,
        // et une ligne de plus par manche y déborderait sous la barre de
        // navigation. Là-bas, ce qui se compare est la dette d'arrivée.
        manches: [
            { roman: "I", label: "sans IA", tours: [5, 5, 5, 5, 5], total: "25", parTour: "5,0", detteDepart: 32, dette: 37, ton: "neutre" }
        ],
        // ⚠️ 08/09 — LA FILE D'ATTENTE (« ils en demandaient quatorze ») A ÉTÉ
        // RETIRÉE de la slide ET du conducteur, sur décision d'Adrien. Ce n'est
        // pas un oubli. À ce moment de la séance la salle doit retenir UNE
        // chose — la machine est régulière — et un second chiffre en bas de
        // l'écran ouvrait un débat (« pourquoi seulement cinq ? ») quinze
        // secondes avant le pronostic. La trémie continue de se remplir dans la
        // simulation, elle reste visible, et qui la remarque a sa réponse.
        // La `note` qui portait cette réserve a disparu à son tour (voir plus
        // haut) : la consigne, elle, reste — ce chiffre ne revient pas sur cette
        // slide sans qu'on en reparle.
    },
    // ⚠️ 08/09 — CES DEUX SLIDES ONT ÉTÉ INVERSÉES (le pronostic était en 7,
    // les rendements en 8). On faisait parier la salle À L'AVEUGLE, puis on lui
    // donnait les chiffres : le pari ne coûtait rien, personne ne se trompait
    // vraiment, et la main levée n'engageait personne. Dans cet ordre-ci, la
    // salle voit ×4 / ×3 / ×0,7 AVANT de parier — elle parie donc en
    // connaissance de cause, et c'est la seule façon que le démenti de la
    // manche II soit un vrai démenti.
    // Conséquence à ne pas défaire : la slide 9 (« les trois chiffres d'il y a
    // trente secondes ») ne suit plus immédiatement les rendements. Le
    // conducteur dit maintenant « d'il y a une minute ».
    {
        chapitre: "L'usine",
        num: 7,
        type: "content",
        template: "grid",
        title: "Ce que l'IA change dans la machine",
        subtitle: "Les augmentations sont volontairement optimistes.",
        // ⚠️ 09/09 — LE FACTEUR EST SORTI DU TITRE ET IL EST COLORÉ. Il était
        // dans la chaîne du titre (« Rédiger ×4 »), donc de la même couleur que
        // le reste : les trois cartes se lisaient à l'identique, et le seul fait
        // qui compte sur cette slide — DEUX MONTENT, UN DESCEND — se déduisait
        // en lisant trois chiffres au lieu de se voir. Deux verts, un rouge :
        // c'est vu du fond de la salle avant d'être lu.
        // Et « ×0,7 » est devenu « −30 % » à la demande d'Adrien : un facteur
        // inférieur à 1 demande une conversion mentale, une baisse en pourcentage
        // ne demande rien. L'unité n'est plus la même que celle des deux autres,
        // c'est assumé — la carte rouge n'a pas à se comparer aux vertes, elle a
        // à contredire.
        items: [
            {
                icon: "penline",
                title: "Rédiger",
                valeur: "×4",
                valeurTon: "gain",
                desc: "Écrire une demande ne coûte presque plus rien."
            },
            {
                icon: "code",
                title: "Coder",
                valeur: "×3",
                valeurTon: "gain",
                desc: "Le code sort massivement plus vite. C'est le seul chiffre que tout le monde retient."
            },
            {
                icon: "eye",
                title: "Relire",
                valeur: "−30 %",
                valeurTon: "perte",
                desc: "Le seul qui recule. Des lots plus gros, moins expliqués : la revue coûte plus cher par feature."
            }
        ],
        // ⚠️ CHIFFRES LUS DANS LE MOTEUR — `YIELDS` de public/usine/src/config/
        // rounds.js : tester (VALIDER) 0,625 → 0,850 = +36 % ; recetter (MISE EN
        // PROD) 1,000 → 1,200 = +20 %. Ils sont ici en petit et volontairement :
        // ce sont de vrais gains, ils existent dans la simulation, et les taire
        // donnait une slide attaquable (« vous n'avez modélisé l'IA que là où ça
        // vous arrange »). Mais ils ne sont pas le sujet : leur petitesse EST
        // l'argument, puisque c'est elle qui laisse le goulot en aval.
        // Une seule ligne, et c'est une contrainte de forme : à deux lignes, la
        // seconde tombait à « forme. » toute seule sous la grille. Ce qui a été
        // coupé — « c'est là que la file se forme » — est du commentaire, donc
        // c'est au conducteur.
        complement: "Côté Ops aussi, mais à peine : valider +36 %, mise en production +20 %."
    },
    {
        chapitre: "L'usine",
        num: 8,
        type: "content",
        template: "statement",
        kicker: "Le pronostic",
        // ⚠️ LE TITRE EST VOLONTAIREMENT PLUS COURT QUE LA PHRASE PARLÉE.
        // Adrien dit à voix haute « on donne des assistants IA à toute
        // l'équipe, du développeur au PO et jusqu'aux Ops — on ne change rien
        // d'autre » ; l'écran n'en garde que la question. Une salle ne lit pas
        // et n'écoute pas en même temps : projeter la phrase entière, c'est
        // choisir que personne n'entende la précision « du développeur au PO »,
        // qui est justement ce qui concerne les trois quarts de la salle.
        title: "On ajoute l'IA dans l'équipe. Combien de features en plus ?",
        // 23/09 — PLUS DE NOTE, à la demande d'Adrien. Elle projetait un vote
        // en 3 options (« Ça monte ? Ça reste à 25 ? Ça descend ? ») pendant
        // que le conducteur n'en fait voter qu'une : la main levée et les
        // doigts pour dire de combien. Le vote se dit, il ne se projette pas.
    },
    {
        chapitre: "L'usine",
        num: 9,
        type: "content",
        template: "factory",
        // PASSAGE 2 : la manche II arrive deja sous IA, reglages inchanges, et
        // se joue TOUR PAR TOUR — c'est le seul endroit de la seance ou l'on
        // veut cinq arrets.
        usine: 2,
        stage: "Manche II — le débordement",
        title: "La cuve Dev accélère",
        subtitle: "Et le débit en sortie baisse.",
        tanks: [
            { label: "PO", fill: 45 },
            { label: "Dev", fill: 100, speed: "×3", overflow: true },
            { label: "Ops", fill: 96, overflow: true }
        ],
        flow: { label: "Débit en sortie", value: 38, trend: "down" },
        overflow: true
    },
    {
        chapitre: "L'usine",
        num: 10,
        type: "content",
        template: "manche-bilan",
        title: "Capacité de codage triplée. Livraison en baisse.",
        subtitle: "Mêmes effectifs, mêmes réglages, même demande. Seuls les rendements ont changé.",
        manches: [
            { roman: "I", label: "sans IA", tours: [5, 5, 5, 5, 5], total: "25", parTour: "5,0", dette: 37, ton: "neutre" },
            { roman: "II", label: "mêmes réglages", tours: [5, 5, 3.5, 4, 3.5], total: "21", parTour: "4,2", dette: 57, ton: "chute" }
        ],
        // 18/09 — « commence au 3e tour » : l'ancienne note disait « pas au
        // dernier » pendant qu'Adrien disait « au 3e tour et au dernier ». Les
        // deux sont vrais (3,5 au tour 3 ET au tour 5), c'est donc le point de
        // départ qui se projette. Nombres en chiffres, comme le reste du deck.
        note: "La chute commence au 3e tour : ce n'est pas un accident de fin de manche. Et la dette passe de 32 à 57 — tout ce qui déborde d'une cuve y tombe."
    },
    {
        chapitre: "L'usine",
        num: 11,
        type: "content",
        template: "standard",
        title: "Pourquoi ça déborde",
        // Deux temps, pas quatre : la salle devine le reste pendant que
        // l'animation tourne. Le seul point non évident est le second.
        points: [
            "En amont, rien n'a changé. Le dev comble les blancs — et une IA les comble magnifiquement.",
            "En aval, tout arrive trois fois plus vite. Et quand ça casse en production, il n'y a plus d'auteur à qui demander pourquoi."
        ]
    },
    {
        chapitre: "L'usine",
        num: 12,
        type: "content",
        template: "statement",
        accent: "red",
        title: "Avec l'IA, si vous ne changez rien, vous produisez moins qu'avant.",
        note: "Pas autant. Moins.",
        // 2e apparition de la voix IA, sur F1, juste après la phrase
        // unique. En `transition`, elle dépendait de la case à cocher masquée
        // sous le compteur de slides — désactivée par défaut.
        voix: "/conference/voix/seminaire-voix-2.mp3",
        action: "f1",
        mode: "tts",
        trigger: "Si je comprends bien votre schéma : vous allez me demander trois fois plus de travail, sans changer une seule de vos procédures. Et c'est moi qu'on appelle l'intelligence artificielle."
    },
    {
        chapitre: "L'usine",
        num: 13,
        type: "content",
        template: "timeline",
        // 18/09 — « Manche III », plus « Tour 3 » : deux slides plus tôt, le
        // « 3e tour » désigne la chute de la manche II. Le même mot pour deux
        // choses différentes, à une minute d'écart, et la salle les confond.
        title: "Manche III — les quatre réglages",
        subtitle: "Votre travail, ce n'est pas de déployer l'IA. C'est de courir derrière le goulot.",
        // Les quatre conseils du conducteur, un par point : le verbe et sa
        // conséquence. Le détail (architecture, sécurité, fonctionnel, tests de
        // vérification) se dit, il ne se projette pas. Le « 5 % » du dernier
        // conseil reste à l'oral : projeté, il n'a pas de dénominateur.
        points: [
            { text: "Clarifier en amont — ce qui n'est pas clarifié sera inventé.", icon: "search" },
            { text: "Doser le contexte — assez pour poser un cadre, pas au point qu'il se contredise.", icon: "layout" },
            { text: "Mettre l'IA sur vos goulots — pas sur ce qui va déjà assez vite.", icon: "target" },
            { text: "Automatiser le prochain goulot — sinon le gain s'arrête à l'étape suivante.", icon: "zap" }
        ]
    },
    {
        chapitre: "L'usine",
        num: 14,
        type: "content",
        template: "factory",
        // PASSAGE 3 : la manche III arrive DEJA REGLEE — le presentateur
        // commente les curseurs qui ont bouge pendant que la salle les voit —
        // puis les cinq tours d'un trait.
        usine: 3,
        stage: "Manche III — le rééquilibrage",
        title: "Les cuves se rééquilibrent",
        subtitle: "L'IA ne supprime pas le goulot. Elle le déplace.",
        tanks: [
            { label: "PO", fill: 70 },
            { label: "Dev", fill: 65 },
            { label: "Ops", fill: 70 }
        ],
        flow: { label: "Débit en sortie", value: 85, trend: "up" },
        points: [
            "Le débit remonte. Mais pas au tour suivant."
        ]
    },
    {
        chapitre: "L'usine",
        num: 15,
        type: "content",
        template: "manche-bilan",
        title: "On a retiré du temps à coder. Le débit est monté.",
        manches: [
            { roman: "I", label: "sans IA", tours: [5, 5, 5, 5, 5], total: "25", parTour: "5,0", dette: 37, ton: "neutre" },
            { roman: "II", label: "mêmes réglages", tours: [5, 5, 3.5, 4, 3.5], total: "21", parTour: "4,2", dette: 57, ton: "chute" },
            { roman: "III", label: "rééquilibrée", tours: [5, 5, 5, 5, 8], enVert: [4], total: "28", parTour: "5,6", dette: 21, ton: "gain" }
        ],
        note: "Et le gain n'arrive qu'au cinquième tour. La chaîne compte cinq maillons et le travail avance d'un maillon par tour : un réglage fait en haut met cinq tours à se voir en bas."
    },
    {
        chapitre: "L'usine",
        num: 16,
        type: "content",
        template: "factory",
        variant: "curve",
        // 24/09 — plus de `stage: "La courbe en J"` au-dessus du titre :
        // Adrien ne prononce plus l'expression, la slide ne l'écrit plus.
        // 24/09 — plus « On produit moins avant de produire plus » : quatre
        // minutes après la phrase unique (slide 12), « produire moins » revenait
        // avec un autre sens. La phrase unique parle de NE RIEN changer ; cette
        // slide, du coût de CHANGER. Le titre nomme maintenant la cause.
        title: "Changer coûte d'abord. Ça rapporte ensuite.",
        // 24/09 — FUSION AVEC L'ANCIENNE SLIDE 17 (« Aux sponsors », le retour
        // sur investissement mesuré au creux). Les deux disaient la même chose :
        // la courbe reste, et la formule de la 17 devient le sous-titre. C'est
        // celle que l'ÉQUIPE PILOTE photographiera pour sa direction. Toutes
        // les slides suivantes ont perdu un cran, conducteur compris.
        subtitle: "Un creux annoncé est un investissement. Un creux découvert est un échec.",
        // Pas de point projeté : la phrase sur le retour sur investissement se
        // dit (voir le conducteur), la courbe se lit seule.
    },

    // ───────────────────── Preuve terrain (0:22:41 → 0:40:51) ─────────────────
    // CAS Nº 1 — PULSE. La seule preuve réelle de la thèse de l'usine : sans ces
    // deux slides, les tours 1-2-3 restent une simulation que rien ne valide.
    // Ici le tour 2 (la cuve Dev accélère, l'amont déborde) et le tour 3
    // (renforcer l'amont) se sont produits pour de bon, sur le nouvel ERP.
    //
    // ⚠️ C'EST LE CAS LE PLUS ÉLOIGNÉ DE LA SALLE, et il ouvre le chapitre.
    // 30 personnes, des user stories, du cloud multi-tenant : le socle n'a rien
    // de tout ça. Ne pas déplacer ni supprimer pour autant — c'est lui qui valide
    // le modèle, et les deux suivants s'appuient dessus. On l'assume à l'oral :
    // « ce premier cas n'est pas le vôtre, je vous le montre parce que c'est
    // celui qui prouve le mécanisme ; les deux suivants sont chez vous. »
    // Dit franchement, l'écart devient un gage d'honnêteté. Non dit, la salle
    // décroche pendant deux slides et ne revient pas tout de suite.
    //
    // Passe du 13/09 : l'ancienne slide 20 (le « ×4 » en grand chiffre) a été
    // supprimée. Le ×4 est remonté dans le titre de la 19, et toutes les slides
    // suivantes ont perdu un cran — conducteur compris.
    {
        chapitre: "Preuve terrain",
        cas: CAS[1],
        num: 17,
        type: "content",
        template: "statement",
        // Le titre prend le ton du cas. C'est le seul chapitre du deck où la
        // couleur d'un titre veut dire quelque chose — elle annonce qu'on change
        // de produit, et elle est ensuite tenue par le bandeau jusqu'au cas
        // suivant. Doit toujours valoir CAS[1].ton.
        accent: "cyan",
        kicker: "Cas nº 1 — PULSE, le nouvel ERP",
        // Le contexte, dans les termes du conducteur. « 3 cas, 3 fois la même
        // méthode, 3 réponses différentes » ouvre le chapitre à l'oral : projeté,
        // il volerait la chute des slides de la charnière.
        title: "30 personnes, des user stories, une mise en production toutes les 6 semaines, du cloud multi-tenant.",
        note: "C'est ce cas qui a fait naître la simulation. On l'a vécu en vrai, sans l'avoir prévu."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[1],
        num: 18,
        type: "content",
        template: "standard",
        title: "On a renforcé l'amont. Rédaction des US : ×4.",
        subtitle: "Même avant l'IA, les PO peinaient à alimenter la squad.",
        // Le DOR seulement, pas le DOD : c'est sur lui que portent les premiers
        // retours. Ce qui se dit sans se projeter : Claude comme outil de
        // rédaction, les allers-retours que coûtent les trous, et les gains
        // ponctuels qui ont servi d'exemple.
        points: [
            "Un PO accompagné : des skills, et des US livrées en markdown dans le dépôt git.",
            "Mais des US trop verbeuses, et des trous comblés par la solution la plus probable — pas forcément celle voulue.",
            "Le DOR respecté : les premiers retours sont très positifs.",
            "Pas encore de gain généralisé. En test et en revue de code, tout le monde tire la langue."
        ]
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 19,
        type: "content",
        template: "big-number",
        // OUVERTURE DU CAS depuis la coupe de l'ancienne slide 22. Celle-ci
        // projetait « pas de correctif, aucune ligne de code écrite » — c'est
        // mot pour mot la chute de CETTE slide, dite une minute plus tôt : on
        // donnait la chute avant le chiffre. Le cas s'ouvre maintenant sur les
        // deux « 200 », et la chute retombe où elle doit.
        accent: "amber",
        kicker: "Cas nº 2 — l'ERP historique",
        // Les deux « 200 » côte à côte : l'égalité EST le message. Un appel coûte
        // une journée entière de développeur, et au bout de cette journée il n'y
        // a pas une ligne de code. Ne pas remplacer par un ratio calculé — c'est
        // la salle qui doit faire le rapprochement, pas la slide.
        //
        // Le dénominateur est TOUT. Mesuré sur une équipe de 10 : un développeur
        // sur dix. Sans « sur une équipe de 10 », la salle rapporte spontanément
        // les 200 jours aux 150 personnes du déploiement — soit 1 %, et le chiffre
        // s'effondre. La révélation du dénominateur se fait à l'oral, après un
        // temps : c'est là qu'est la bascule.
        figures: [
            { value: "200", label: "appels par an" },
            { value: "200", label: "jours de développeur" }
        ],
        // 21/09 — LES DEUX « 200 » COMPTENT ENSEMBLE, de 0 à 200, et se posent
        // sur la même image. L'égalité n'est plus lue, elle est vue arriver.
        // « Un appel. Un jour. » attend qu'ils aient fini (~3 s).
        // ⚠️ Pas de grille de 200 cases, pas de calendrier : l'un comme l'autre
        // montrerait « une personne toute l'année », qui se dit après le
        // dénominateur et ne se projette pas.
        effet: "compteur",
        // Passe du 14/09, à la demande d'Adrien : la traduction s'arrête à « Un
        // appel. Un jour. », et la note est retirée. Le motif de clôture, l'équipe
        // de 10 et « tous les jours une personne » se disent, ils ne se projettent
        // plus.
        translation: "Un appel. Un jour."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 20,
        type: "content",
        template: "statement",
        // La salle va objecter — à juste titre — que 200 jours, à son échelle,
        // ce n'est rien. On ne gonfle pas le chiffre : on change ce qu'on lui
        // demande de porter. Le volume ne se transpose pas ; le TAUX se
        // transpose. Plus l'organisation est grande, plus chaque question coûte
        // cher.
        // Passe du 14/09 : plus rien sous le titre. Le coupable (la
        // documentation) et l'image de l'entrepôt sans étiquettes se disent.
        title: "Plus l'organisation est grande, plus chaque question coûte cher."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 21,
        type: "content",
        template: "standard",
        // Les anciennes 22 (« on ne documente plus pour qu'un humain lise ») et
        // 23 (« tout le monde la réclame, personne ne la lit ») fusionnées le
        // 14/09 : les deux vérités du conducteur, et elles seules. Les captures
        // d'écran, le schéma et les métadonnées se disent.
        title: "Deux vérités désagréables",
        points: [
            "Quasiment personne ne lit la documentation — même quand elle existe, même quand tout le monde la réclame.",
            // 18/09 — « d'abord », plus « uniquement » : devant des équipes qui
            // lisent des procédures à 3 h du matin en astreinte, l'exclusif se
            // conteste en une phrase. La priorité, non.
            "On ne documente plus d'abord pour qu'un humain lise. On documente d'abord pour l'IA."
        ]
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 22,
        type: "content",
        template: "standard",
        // Le projet (14/09). « Quelques semaines » ne se projette pas : c'est la
        // bascule du passage (« ce qui se transpose, ce n'est pas 750 »), et
        // écrite, elle serait lue avant d'être dite. Le dernier point sort après
        // la question « pourquoi personne ne l'avait fait avant ? ».
        // La voix IA a suivi le F1 du conducteur, qui tombe désormais ici.
        title: "L'ERP rétro-documenté par l'IA",
        points: [
            "Une IA lancée sur tout le code source : plus de 10 repos pour le cœur de l'ERP, plus de 200 repos spécifiques.",
            "Plus de 750 documents générés en automatique, dans une arborescence conçue pour l'IA.",
            "Relus par des experts pour les fonctionnalités importantes.",
            "Ce que l'IA déplace, ce n'est pas la difficulté. C'est le seuil de rentabilité."
        ],
        voix: "/conference/voix/seminaire-voix-3.mp3",
        action: "f1",
        mode: "tts",
        trigger: "Sept cent cinquante documents ? Je les ai tous lus pendant que vous lisiez cette phrase. Voulez-vous que je vous dise lesquels se contredisent ?"
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 23,
        type: "content",
        template: "statement",
        // 24/09 — LA DÉMO, à la place de « Pourquoi ça marche » (3 cartes).
        // Retour de la répétition : après l'usine, les trois cas tenaient vingt
        // minutes de slides sans respiration. Adrien sort du diaporama et montre
        // l'outil de recherche dans la documentation de l'ERP : la même question
        // posée avec deux personas. Les prompts système et les personas ne
        // s'expliquent plus, ils se voient.
        //
        // Cette slide est le décor d'avant et d'après la démo : elle reste
        // derrière la fenêtre de l'outil, et c'est sur elle qu'on revient pour
        // raconter la mesure (sous-agents, IA évaluatrice), qui prépare les
        // 30 % de la slide suivante. Pas de chiffre ici : ils volent la 24.
        kicker: "En direct",
        title: "Une même question. Une réponse par profil.",
        note: "L'outil de recherche dans la documentation de l'ERP."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 24,
        type: "content",
        template: "big-number",
        // Espaces insécables (\u00a0) avant les « % » : sans elles, le signe peut
        // passer seul à la ligne sous le chiffre.
        figures: [
            { value: "30\u00a0%", label: "résolus en totale autonomie" },
            // 18/09 — plus de « + » devant le second : devant une valeur, il se
            // lit comme une hausse. Deux « 30 % » côte à côte, comme les deux
            // « 200 » du début du cas : ce sont les labels qui les distinguent.
            { value: "30\u00a0%", label: "résolus en partie" }
        ],
        // 24/09 — chaque libellé collé sous SON chiffre : trop espacés, les
        // « 30 % » et leurs catégories se lisaient comme deux lignes séparées.
        serre: true,
        // Passe du 14/09 : plus de traduction sous les chiffres. Celui de
        // droite se commente à l'oral — c'est « le plus important des 2 ».
        //
        // 22/09 — LES 100 % SONT REVENUS, ET AVEC EUX LES 4 %.
        // Le 21/09, une question de la salle a révélé qu'une partie du public
        // avait compris de cette slide que l'IA ne se trompait pas. Deux bons
        // chiffres seuls, ça s'entend comme une promesse. La barre rétablit le
        // compte : 30 + 30 + 4 + 36 = 100, et le 4 % des réponses fausses
        // affirmées avec assurance est le seul segment rouge de la slide.
        // Il est petit à dessein — il est à l'échelle, et à l'oral il se
        // compare au taux d'erreur des humains sur les appels de 2025.
        effet: "repartition",
        // ⚠️ LIBELLÉS COURTS, et volontairement pas ceux des 2 gros chiffres
        // du haut : la légende est un RÉCAPITULATIF, pas une deuxième
        // annonce. Répéter « résolus en totale autonomie » à 20 cm sous
        // lui-même donne à la salle l'impression d'avoir mal lu la première
        // fois. Les 2 chiffres du haut nomment, la barre compte.
        repartition: [
            { value: 30, label: "en autonomie", ton: "cyan" },
            { value: 30, label: "en partie", ton: "cyan", retrait: true },
            { value: 4, label: "faux, avec assurance", ton: "red" },
            { value: 36, label: "« je ne sais pas »", ton: "neutre" }
        ],
        note: "Testé sur les tickets de l'année précédente, dont la résolution était connue : la machine a corrigé sa propre copie · sans optimisation encore poussée, pas encore déployé"
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[2],
        num: 25,
        type: "content",
        template: "timeline",
        // LA SLIDE DE CETTE SALLE. Une équipe d'experts au service de centaines
        // d'applications ne se demande pas comment coder plus vite : elle se
        // demande comment cesser d'être appelée pour ce qu'elle sait déjà.
        //
        // 18/09 — THÈSE RETOURNÉE, sur la position d'Adrien. L'ancienne version
        // disait « l'IA remplace l'expert : c'est faux ». Or le cas nº 2 montre
        // exactement une IA qui répond à la place de l'expert — la slide niait ce
        // que la slide d'avant venait de mesurer. La position tenue maintenant :
        // l'IA remplace l'expert SUR LES RÉPONSES, et c'est l'expert qui la
        // construit, l'enrichit et la maîtrise. Son métier n'est plus de répondre,
        // c'est d'améliorer l'IA. Son expertise ne sert plus une personne à la
        // fois : elle est multipliée.
        //
        // Dit franchement, c'est plus rassurant que le démenti : une salle
        // d'experts sait qu'on ne la croit pas quand on lui dit « rien ne va
        // changer pour vous ». Elle entend en revanche « votre expertise vaut
        // davantage, à condition que ce soit vous qui teniez l'IA ».
        //
        // 18/09 (bis) — QUATRE TEMPS, sur l'ajout d'Adrien : entre « vous la
        // construisez » et « il ne vous appelle plus », une étape où l'IA
        // propose et où l'expert valide AVANT l'envoi. C'est elle qui rend le
        // passage crédible : on ne donne l'IA aux demandeurs qu'une fois qu'elle
        // a fait ses preuves sous contrôle de l'expert.
        //
        // La dernière ligne casse la structure. Ne jamais la réécrire en « il
        // vous appelle moins » : c'est « ils ne vous appellent plus » qui fait
        // le sujet du talk. Repris en ligne 2 de la slide 32 (« l'expert IA que
        // vous voulez créer »). « Votre métier : l'améliorer, la maîtriser » se
        // dit.
        //
        // 23/09 — PLUS DE SOUS-TITRE, à la demande d'Adrien. Il projetait
        // « C'est l'expert qui la construit » : ce n'est pas forcément lui (la
        // documentation ERP a été construite par Adrien, qui n'est pas expert).
        // L'expert est là pour l'aider au départ et l'améliorer — ça se dit.
        title: "L'expertise se multiplie",
        points: [
            { text: "Aujourd'hui — il vous appelle. Vous cherchez. Vous répondez. Une question à la fois.", icon: "phone" },
            { text: "Première étape — vous construisez l'IA avec ce que vous savez.", icon: "brain" },
            { text: "Deuxième étape — l'IA propose la réponse. Vous la validez avant l'envoi, et chaque correction l'enrichit.", icon: "shield" },
            { text: "Ensuite — quand elle est fiable, vous la donnez à vos demandeurs. Ils ne vous appellent plus.", icon: "users" }
        ]
    },

    // CAS Nº 3 — LA FORGE. Le cas destiné à la moitié infra / exploitation de la
    // salle : environnements, provisionnement, automatisation. C'est aussi le
    // troisième goulot, et il n'est ni en amont (PULSE) ni en entrée (ERP) — il
    // est À CÔTÉ de la chaîne, dans ce qui la fait tourner. Sans lui, la
    // charnière n'a que deux points et se lit comme une coïncidence.
    //
    // ⚠️ HONNÊTETÉ, ET C'EST CE QUI REND LE CAS FORT. Le plafond de 1000 jours a
    // été décidé en DÉCEMBRE 2025, avant même que l'IA soit disponible pour les
    // équipes. La décision est donc antérieure à l'outil : c'était un pari sur
    // la concentration (plafonner, arrêter tout le reste, top priorité
    // entreprise), pas sur la technologie. L'IA est arrivée en cours de route et
    // explique le dépassement de périmètre à l'intérieur du plafond — jamais le
    // plafond lui-même.
    //
    // Ne jamais retirer la date de la note. Elle répond à la question que ces
    // managers vont se poser en silence : « faut-il attendre que l'IA soit mûre
    // pour s'engager ? » Non. L'engagement est venu d'abord.
    //
    // À DIRE, jamais à projeter : « je ne suis pas expert du sujet, c'est le
    // travail des équipes techniques — je vous rapporte le résultat. » Le dire
    // AVANT les chiffres ; après, ça sonne comme une excuse.
    //
    // 14/09 — MOINS DE TEXTE, à la demande d'Adrien. Le titre ne garde que le
    // pari, en deux chiffres ; le reste se dit (l'ERP de 30 ans, le château
    // de cartes, CVS, « en espérant en faire la moitié »). La note ne porte
    // plus que la date : c'est le passage « ce n'est pas un miracle de l'IA »,
    // qui se dit pendant que cette slide est encore à l'écran. « Nous avons
    // dépassé le périmètre » est sorti de la note — c'est la chute de l'oral,
    // et écrite elle était lue avant d'être dite.
    //
    // 24/09 — CAS RÉÉCRIT, L'IA D'ABORD. Retour de la répétition : le cas se
    // vivait comme un long monologue, et la salle ne voyait le lien avec l'IA
    // qu'au bout de deux minutes et demie d'histoire. Nouvel ordre :
    //   26 — le goulot : pourquoi la forge en était un, et pourquoi l'IA allait
    //        en faire LE goulot (renvoi à la cuve Ops de la manche II) ;
    //   27 — la décision : le château, 3000 → 1000, décembre 2025 ;
    //   28 — le résultat : 15 jours → 1 heure, puis ce qu'a fait l'IA et la
    //        leçon des grandes orientations, dites sur ce chiffre.
    // L'ancienne 28 (« L'IA accélère ceux qui savent s'en servir », 3 cartes)
    // est retirée : son contenu se dit sur le résultat.
    {
        chapitre: "Preuve terrain",
        cas: CAS[3],
        num: 26,
        type: "content",
        template: "statement",
        // Doit toujours valoir CAS[3].ton.
        accent: "violet",
        kicker: "Cas nº 3 — la forge logicielle",
        // La thèse du cas, et le lien avec l'IA dès la première phrase. Pas de
        // « 15 jours » ici : il se dit, et il est projeté en slide 28, où il
        // s'effondre.
        title: "Plus l'IA code vite, plus il faut d'environnements pour tester."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[3],
        num: 27,
        type: "content",
        template: "statement",
        accent: "violet",
        // L'ouverture du cas est passée à la slide 26 : le kicker ne redit pas
        // « la forge logicielle », il dit où on en est dans le cas.
        kicker: "La décision",
        // 23/09 — LE CHÂTEAU DE CARTES, en 3 appuis (idée d'Adrien) :
        //   ouverture — il se construit, « par ajouts successifs » ;
        //   appui 1 — « quand il faut toucher aux fondations… » : il
        //             s'effondre, puis « plus de 3000 jours » se pose ;
        //   appui 2 — « …travailler autrement » : il se reconstruit, puis
        //             « 1000 jours » arrive et 3000 recule ;
        //   appui 3 — « décembre 2025 » : la note.
        // Avant, « 3000 / 1000 » était à l'écran pendant les 30 secondes
        // d'histoire de la forge et se lisait avant d'être dit. Le conducteur
        // a été réordonné pour que chaque chiffre tombe avec son mot. Mise en
        // scène et calendrier : slides/templates/Chateau.jsx.
        // Le `title` n'est plus projeté : il reste la légende du prompteur.
        intro: "chateau",
        etapes: 3,
        chateau: {
            avant: { label: "Chiffrée à plus de", value: "3000 jours" },
            apres: { label: "Lancée avec", value: "1000 jours" }
        },
        title: "Chiffrée à plus de 3000 jours. Lancée avec 1000.",
        note: "Décidé en décembre 2025 — avant que nos équipes aient accès à l'IA."
    },
    {
        chapitre: "Preuve terrain",
        cas: CAS[3],
        num: 28,
        type: "content",
        template: "big-number",
        // Le chiffre le plus spectaculaire du talk, et le seul qui tombe dans le
        // métier exact d'une partie de la salle. Les deux valeurs se lisent en
        // une seconde ; les labels portent le vrai basculement, qui n'est pas la
        // durée mais la disparition de l'expert dans la boucle.
        figures: [
            { value: "15 jours", label: "hier · uniquement par des experts" },
            { value: "1 heure", label: "aujourd'hui · en libre-service" }
        ],
        // 21/09 — L'EFFONDREMENT. « 15 jours » arrive seul avec une barre
        // pleine largeur ; au bout de ~2 s la barre s'écrase jusqu'à la
        // longueur d'une heure à la même échelle, et « 1 heure » apparaît à ce
        // moment-là. Le temps de dire « 15 jours » avant la chute : ~2 s, pas
        // plus — ne pas commenter la barre, la laisser tomber.
        // ⚠️ `echelle: 360` suppose 15 jours CALENDAIRES (du délai, comme
        // « 1 heure »). Si ce sont des jours ouvrés d'expert, mettre 105.
        effet: "effondrement",
        echelle: 360,
        // 14/09 — plus de note. Elle portait le paradoxe des 300 machines
        // virtuelles pour 300 salariés, qui n'est plus dans le texte parlé : une
        // note que l'orateur ne commente pas se lit à sa place. La remettre avec
        // sa phrase dans le conducteur, jamais sans.
        translation: "Créer un environnement ERP complet, serveur dédié et jeu de données compris."
    },
    {
        chapitre: "Preuve terrain",
        num: 29,
        type: "content",
        template: "grid",
        // LA CHARNIÈRE, SECOND TEMPS — la seule slide de la conférence qui soit
        // un OUTIL et pas une démonstration. Elle retourne les trois cas : ils
        // cessent d'être trois anecdotes pour devenir trois SONDES, chacune
        // formulée comme une consigne applicable dans une organisation qui
        // n'écrit pas de code.
        //
        // C'est aussi la matière que les coachs (public C) attendent pour les
        // ateliers de l'après-midi : jusqu'ici on leur confiait les papiers de
        // la slide 37 sans rien pour les trier.
        //
        // Chaque carte tient trois choses dans cet ordre, et l'ordre compte :
        // l'endroit, la consigne de recherche, puis la preuve qu'on vient de
        // passer vingt minutes à établir. La preuve en dernier — c'est un
        // rappel, pas l'argument.
        //
        // ⚠️ LES `ton` NE SONT PAS DE LA DÉCORATION, et c'est ici que tout le
        // dispositif de couleurs se rembourse. La salle a suivi le cyan pendant
        // trois slides, l'ambre pendant douze, le violet pendant trois : les trois
        // reviennent d'un coup dans le même écran, une par carte, dans l'ordre où
        // ils sont passés. Le rapprochement se fait avant la première phrase.
        // Retirer les `ton` ne casse rien à l'affichage — ça enlève juste
        // l'argument, en silence. Et l'ordre des cartes DOIT rester l'ordre des
        // cas.
        //
        // 20/09 — LES TITRES SUIVENT LE CONDUCTEUR, pas l'inverse. Ils étaient
        // « En amont » / « Avant la chaîne » / « À côté de la chaîne » : une
        // série spatiale cohérente à l'écrit, mais qu'Adrien ne prononce pas.
        // Il dit « sur la phase amont », « sur votre équipe », « sur
        // l'outillage » — la salle lisait donc trois titres pendant qu'elle en
        // entendait trois autres. Le conducteur gagne : c'est lui qui sort de
        // la bouche. Toute reformulation future part du conducteur.
        //
        // 20/09 — CARTES RÉDUITES DE MOITIÉ (88 mots → 52), à la demande
        // d'Adrien, et reformulées par lui. Trois règles en sont sorties :
        //
        //  1. La carte ne garde QUE la consigne et la preuve chiffrée. Tout ce
        //     qu'Adrien dit déjà au micro est parti de l'écran (« regardez la
        //     file devant votre équipe », « personne ne compte ça comme du
        //     délai »). Ce qui reste est ce que la salle doit RELIRE, pas
        //     entendre deux fois.
        //
        //  2. LES CHIFFRES NE SE COUPENT JAMAIS. 200 appels / 200 jours et les
        //     15 jours de la forge sont le remboursement des 15 slides
        //     précédentes, et la seule chose que la salle photographie. Une
        //     version sans eux a été écartée pour ça. La carte cyan est la
        //     seule sans chiffre : PULSE n'en a pas dans le talk (le
        //     « 30 % / +30 % » de la slide 25 appartient au cas ERP).
        //
        //  3. Les trois lignes sont parallèles — « Ce qui… / Ce qu'elle… /
        //     Ce qui… », puis « Ici : » et la preuve. C'est ce parallélisme qui
        //     fait lire les trois cartes d'un coup au lieu d'une par une. Toute
        //     réécriture d'une seule carte doit le conserver sur les trois.
        //
        //  4. La preuve vit dans `item.preuve`, pas dans `desc` : le template
        //     la pose en dessous, plus petite et plus sourde. `desc` = la
        //     consigne, pour la salle ; `preuve` = le cas d'Adrien, qui la
        //     crédibilise. Les remettre sur une seule ligne, c'est redonner le
        //     même poids aux deux et laisser l'œil choisir au hasard.
        //
        // ⚠️ « Ce qu'elle doit faire pour produire » (carte ambre) est
        // d'Adrien et remplace « ce qu'elle fait quand elle ne produit rien » :
        // la recherche d'information est un PRÉALABLE au travail, pas du
        // déchet. Le conducteur dit ensuite que l'IA la raccourcit, jamais
        // qu'elle la supprime. Ne pas revenir à une formulation qui la traite
        // comme une perte.
        title: "Où chercher le vôtre",
        // Le refus de la recette, écrit noir sur blanc. Il était jusqu'ici
        // implicite (slide 2, à l'oral) et la salle pouvait légitimement en
        // ressortir avec « il ne nous a pas dit comment faire ».
        subtitle: "Ma réponse ne vous servira à rien. Ce qui me l'a fait trouver trois fois, si.",
        items: [
            {
                icon: "inbox",
                ton: "cyan",
                title: "La phase amont",
                desc: "Ce qui attend d'entrer, et dans quel état.",
                preuve: "Ici : les PO n'alimentaient plus la squad."
            },
            {
                icon: "phone",
                ton: "amber",
                title: "Votre équipe",
                desc: "Ce qu'elle doit faire pour produire.",
                preuve: "Ici : chercher l'information — 200 appels, 200 jours."
            },
            {
                icon: "wrench",
                ton: "violet",
                title: "L'outillage",
                desc: "Ce qui permet à vos équipes de travailler.",
                preuve: "Ici : la forge — 15 jours pour un environnement."
            }
        ]
    },

    // ─────────────────────── Et maintenant (0:40:51 → 0:44:48) ─────────────────────
    // 18/09 — le chapitre s'appelait « Le run ». Renommé à la demande d'Adrien :
    // le mot désignait un métier de la salle, pas le moment du talk.
    {
        chapitre: "Et maintenant",
        num: 30,
        type: "content",
        template: "statement",
        // ⚠️ SLIDE ENTIÈREMENT RÉÉCRITE. L'ancienne titrait « Vous êtes l'aval
        // de quelqu'un d'autre », et gardait le retournement pour la fin de
        // l'oral. Quatre défauts, tous retenus :
        //
        //  1. Trop frontale. Elle annonçait à la salle que ça allait lui
        //     tomber dessus, et le retournement arrivait trente secondes plus
        //     tard — trente secondes pendant lesquelles la moitié de la salle
        //     n'écoutait déjà plus.
        //  2. Elle contredisait la thèse. Pendant quarante minutes : « le
        //     goulot est local, je refuse de vous donner ma réponse. » Puis on
        //     la donnait. L'équipe pilote — celle qu'on interrogera après —
        //     entendait la pirouette.
        //  3. Elle se marchait dessus avec la slide suivante : deux images
        //     finales concurrentes, la cuve d'un côté, le rempart de l'autre.
        //  4. Elle ne débouchait sur rien.
        //
        // LE RENVERSEMENT EST DANS LE TITRE. La conséquence heureuse est ce
        // qu'on projette ; le mécanisme, lui, passe en note. Ce n'est plus une
        // prédiction, c'est une position dans la chaîne — et une position se
        // vérifie, elle ne se croit pas. La menace devient une subordonnée.
        //
        // On reste dans l'image hydraulique de l'usine, la seule qu'on ait
        // démontrée pendant quarante minutes. Toute autre métaphore introduite
        // ici concurrencerait la seule chose que la salle a vue fonctionner.
        //
        // ⚠️ Pas d'`accent: "red"` : la phrase unique en a besoin deux écrans
        // plus loin, et deux rouges rapprochés se neutralisent.
        //
        // ⚠️ Repose sur le fait qu'ils exploitent ce que d'autres écrivent.
        // Si une partie de la salle développe : « pour la plupart d'entre
        // vous ». Voir la décision en attente.
        // 18/09 — NOUVEAU TITRE, choisi par Adrien. L'ancien (« L'étage qui va
        // décider du débit de toute cette maison, c'est le vôtre ») était
        // solennel et ne s'appuyait sur rien de montré. Celui-ci reprend la
        // thèse de l'usine (« l'IA ne supprime pas le goulot, elle le déplace »)
        // et l'applique à leur étage : ce n'est pas une prédiction de plus, c'est
        // la démonstration refaite pour eux.
        title: "Quand le développement accélère, le goulot se déplace.",
        // 18/09 — PLUS DE NOTE, à la demande d'Adrien, qui n'était pas à l'aise
        // avec elle. Le mécanisme (« ils ne doubleront pas leurs incidents, ils
        // doubleront les vôtres ») se dit, il est dans le conducteur.
    },
    {
        chapitre: "Et maintenant",
        num: 31,
        type: "content",
        template: "standard",
        // 18/09 — FUSION DES ANCIENNES 33 ET 34, sur l'idée d'Adrien.
        //
        // L'ancienne 33 (« Votre nouveau livrable, ce n'est plus la réponse. C'est
        // ce qui permet de la construire sans vous ») était une consigne. La 34
        // (« Écrivez deux lignes ») en redonnait une autre trente secondes plus
        // tard, et la note de la 33 disait « c'est la seule chose que je vous
        // demande ». Deux fins, une contradiction.
        //
        // La ligne 2 absorbe la 33 en la rendant concrète : le « nouveau
        // livrable » devient un expert IA à créer, c'est-à-dire exactement ce que
        // le cas nº 2 a construit. « Pour qu'on ne vous appelle plus » referme
        // « L'expertise se multiplie » (slide 26) mot pour mot. L'argument du
        // livrable (la réponse → ce qui permet de la construire) se dit.
        //
        // La ligne 1 est le goulot de la slide 3 (« gardez-la, on y revient à la
        // fin »), tourné vers l'action : pas « votre goulot », mais celui sur
        // lequel on travaille en premier. Le « avec votre équipe » garde le rôle
        // de relais de la salle, qui portait l'ancienne ligne 2.
        //
        // Ce sont deux choses à trancher, pas des questions : une question
        // projetée se lit comme une affirmation de plus.
        //
        // 20/09 — PLUS AUCUNE CONSIGNE D'ÉCRITURE, à la demande d'Adrien. La
        // slide disait « Écrivez deux lignes » et le conducteur « je vais vous
        // demander 2 lignes ». Adrien, quand il est dans la salle, trouve ce
        // type de consigne pénible : elle transforme une conférence en exercice,
        // et elle exclut d'emblée ceux qui n'ont ni papier ni envie. On demande
        // maintenant deux IDÉES — même contenu, même silence, mais rien à
        // sortir de sa poche. Ne pas réintroduire « écrivez », « notez » ou
        // « papier » dans cette slide, ni dans le conducteur de cette slide.
        //
        // 22/09 — LE SILENCE PASSE DE 30-40 s À 15 s, sur le chrono de la
        // répétition. 40 secondes de silence sont tenables au milieu d'un
        // talk ; à 2 slides de la fin, elles ne le sont plus : la salle a
        // conclu avant l'orateur et attend qu'il termine. Le développement de
        // l'idée 2 a été resserré pour la même raison, et la question finale
        // (« lequel de ces goulots l'IA desserre vraiment ») a été retirée —
        // elle disait par avance la slide 34, qui est faite pour ça.
        //
        // ⚠️ Le « écrire ce que votre équipe est seule à savoir » du conducteur
        // est une AUTRE écriture — celle qui nourrit l'expert IA, au bureau, et
        // c'est le sujet du talk. Elle reste.
        title: "Repartez avec deux idées.",
        subtitle: "",
        // Le 1er appui lance l'analyse des questions de la salle, depuis le
        // prompteur (20 à 60 s, rien ne bouge à l'écran) : la voix sera prête
        // pour la slide 35. Voir « LES ACTIONS À LA FLÈCHE » en tête de fichier.
        action: "synthese",
        points: [
            "1. Le goulot sur lequel vous travaillerez en premier lundi, avec votre équipe.",
            "2. L'expert IA que vous voulez créer, pour qu'on ne vous appelle plus."
        ]
    },

    // ───────────────────────── Clôture (0:44:48 → 0:46:00) ────────────────────
    {
        chapitre: "Clôture",
        num: 32,
        type: "content",
        template: "statement",
        accent: "red",
        title: "Avec l'IA, si vous ne changez rien, vous produisez moins qu'avant. Pas autant. Moins.",
        // 18/09 — PLUS DE NOTE. Elle posait une 3e formule finale (« quel étage
        // va déborder en premier ») entre la phrase unique et la question de la
        // slide 34, sur le même écran que la voix IA : trois fins concurrentes,
        // le défaut déjà corrigé sur les slides du run. La fin appartient à la
        // question de la slide suivante.
        voix: "/conference/voix/seminaire-voix-4.mp3",
        action: "f1",
        mode: "tts",
        trigger: "Vous allez tous rentrer et me demander d'aller plus vite. Aucun d'entre vous ne va me demander où je dois chercher. Je vais encore travailler pour rien."
    },
    {
        chapitre: "Clôture",
        num: 33,
        type: "content",
        template: "statement",
        // La slide conçue pour être photographiée. Rien d'autre à l'écran :
        // la question, le nom, le QR.
        //
        // ⚠️ 19/09 — ELLE N'EST PLUS LA DERNIÈRE DU DECK, mais elle reste celle
        // de la PAUSE. Après « Merci », on passe sur « La salle » (slide 35)
        // pour les questions-réponses, puis ON REVIENT ICI : c'est cet écran-là
        // qui doit être affiché quand la salle se lève et sort son téléphone.
        //
        // ⚠️ LE DERNIER MOT EST ICI, ET IL EST HUMAIN. Il n'existait pas : le
        // conducteur s'arrêtait sur les trente secondes d'écriture, et la
        // dernière chose que la salle entendait était la vanne de la voix IA de
        // la slide précédente. Après quarante-huit minutes sérieuses et
        // chiffrées, finir sur un gag puis un QR code, c'est éteindre soi-même
        // sa propre fin.
        //
        // La voix IA garde sa chute — elle est bonne, et elle porte le thème.
        // Mais Adrien reprend la parole par-dessus CET écran-ci, et le texte
        // est écrit dans le conducteur (§ SLIDE 34). Il boucle sur la question
        // du matin (« comment on va plus vite ? ») et laisse l'autre à l'écran.
        title: "L'IA desserre-t-elle votre goulot — ou accélère-t-elle le reste ?",
        contact: {
            name: "Adrien Giguelay",
            linkedin: "linkedin.com/in/adrien-giguelay-96975987"
        },
        qr: "https://www.linkedin.com/in/adrien-giguelay-96975987"
    },

    // ─────────────────── Questions-réponses (après « Merci ») ─────────────────
    {
        // Le bandeau du haut affiche le CHAPITRE : « La salle » y serait dit
        // trois fois (bandeau, kicker, titre) sur le même écran.
        chapitre: "Questions",
        num: 34,
        type: "content",
        template: "salle",
        // 19/09 — LA SLIDE QUI RENVOIE À LA SALLE CE QU'ELLE A ÉCRIT.
        //
        // Elle vient APRÈS le « Merci » de la slide 34, et on REVIENT sur la 35
        // pour la pause : la 35 est conçue pour être photographiée, c'est elle
        // qui doit rester à l'écran quand tout le monde se lève. Celle-ci n'est
        // là que pendant les questions-réponses.
        //
        // Elle répond aussi à la question laissée ouverte en fin de conducteur
        // (« les ~15 min qui restent — et alors où, puisque la slide 34 reste à
        // l'écran ? ») : les questions ont maintenant un écran à elles.
        //
        // ⚠️ SEULE SLIDE DU DECK DONT LE CONTENU VIENT DU RÉSEAU. Tout le reste
        // tient dans le bundle et se joue hors ligne. Si le backend ne répond
        // pas, elle affiche « Vos questions, maintenant — à voix haute » et
        // Adrien lit les questions depuis le prompteur : c'est le repli prévu,
        // pas une panne visible. Voir `SalleSlide.jsx`.
        //
        // ⚠️ SON CONTENU EST FABRIQUÉ PENDANT LA CONFÉRENCE, par le bouton
        // « ⟳ synthèse » du prompteur : le backend classe les questions,
        // écrit la synthèse (gpt-4o-mini) et en fait un MP3 (TTS). Comptez
        // 20 à 60 s — à lancer vers la slide 30. F1 lit la voix ici même,
        // 5e et dernière apparition (voir la note en tête de fichier).
        // L'écran ne se rafraîchit pas tout seul : il est figé au moment où
        // Adrien l'affiche, et c'est voulu.
        title: "Vos réponses",
        action: "f1",
        accent: "cyan"
    },
    {
        chapitre: "Questions",
        num: 35,
        type: "content",
        template: "salle-questions",
        // 22/09 — LA PREUVE DE CE QUE LA 35 VIENT DE RACONTER.
        //
        // La slide 35 dit maintenant, en premier, que les questions ont été
        // lues, classées et REGROUPÉES par une IA pendant qu'Adrien parlait,
        // et que ça lui a coûté un clic. Une affirmation pareille appelle sa
        // pièce à conviction : celle-ci projette le classement lui-même, les
        // doublons fondus et préfixés de leur « ×N ».
        //
        // ⚠️ ELLE RESTE APRÈS LA 35, JAMAIS AVANT. Les libellés projetés sont
        // écrits par le modèle, pas par Adrien ; ce qui les rend montrables,
        // c'est qu'il vient de les lire sur son prompteur à la slide
        // précédente. Voir `_themes_projetables` dans `backend/salle.py`.
        //
        // ⚠️ SON VOLUME N'EST PAS CONNU À L'AVANCE : 3 questions ou 40. Le
        // template a 3 densités, et les seuils (6 et 12) se comptent en
        // GROUPES, pas en questions — voir SalleQuestionsSlide.jsx.
        //
        // Sans classement (backend muet, synthèse pas lancée), elle affiche le
        // même repli que la 35 : « Vos questions, maintenant — à voix haute ».
        // ⚠️ PAS DE KICKER ICI. Le bandeau de chapitre dit déjà « QUESTIONS »,
        // et un kicker se place sous le logo VIF, en haut à gauche : il
        // passait dessus. La slide 35 n'en a jamais eu pour la même raison.
        title: "Vos questions",
        accent: "cyan"
    }
];

/**
 * RÉSERVE — hors du flux principal.
 *
 * La typing-race matérialise les 750 documents en volume de frappe. Elle est
 * sortie du montage pour cette salle-là : son volume réel n'a jamais été compté
 * (`raceText` est un ordre de grandeur, pas une mesure), et devant un public
 * majoritairement non développeur elle coûte deux minutes que le cas nº 3 — la
 * forge — occupe bien mieux.
 *
 * Pour la remettre : couper l'objet ci-dessous et le recoller juste après la
 * slide « 750 ».
 */
export const seminaireSlidesReserve = [
    {
        chapitre: "Preuve terrain",
        type: "content",
        template: "typing-race",
        title: "Ce que ça représente en frappe pure",
        // La phrase de désamorçage complète se PRONONCE avant d'afficher la
        // course. Ici, seulement ce qu'il en reste une fois la course lancée.
        subtitle: "Pas pour montrer que l'IA écrit vite. Pour montrer ce que cette vitesse a rendu rentable.",
        note: "Ordre de grandeur : Opus 5 écrit à environ 45 mots par seconde. Un humain soutenu, un peu moins d'un mot par seconde.",
        // ⚠️ Volume réel à compter sur le dossier de documentation, pas à estimer.
        raceText: "Rien que pour taper le texte de cette documentation, à vitesse de frappe humaine soutenue, il aurait fallu des mois. Sans lire une ligne de code, sans comprendre un seul programme, sans vérifier quoi que ce soit. Juste taper. Et le vrai travail, lire, comprendre, recouper, relier au code, c'est un ordre de grandeur au-dessus."
    }
];
